import PropTypes from 'prop-types';

import DiffBox from '../../../AllocatedCredits/components/DiffBox';

import styles from './_index.module.scss';

const RenderDiffBox = ({ position, value }) => {
  const show = position === 'left' ? value < 0 : value > 0;

  return (
    <span
      className={`${styles['credit-management-diffbox']} ${styles[`credit-management-diffbox-${position}`]}`}
    >
      {show && <DiffBox value={value} />}
    </span>
  );
};

RenderDiffBox.propTypes = {
  position: PropTypes.oneOf(['left', 'right']).isRequired,
  value: PropTypes.number.isRequired,
};

export default RenderDiffBox;
